import { render, staticRenderFns } from "./IntegrationLists.vue?vue&type=template&id=66e68a3c&"
import script from "./IntegrationLists.vue?vue&type=script&lang=ts&"
export * from "./IntegrationLists.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports